export default __webpack_public_path__ + "static/media/TH.87b909c0.png";